import { now as serverNow } from '~/models/clock'

/**
 * 現在日時から既定の年度を導出する (spec 「年度セレクタ」機能詳細:
 * 既定は当年度)。 4月始まりのため 1〜3月は前年度扱い。
 */
export function defaultFiscalYear(now: Date = serverNow()): number {
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  return month >= 4 ? year : year - 1
}

/** 指定日付の会計年度を導出する (4月始まり)。 */
export function fiscalYearOf(date: Date): number {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  return month >= 4 ? year : year - 1
}

/** 年度セレクタの選択肢 (前後 range 年ずつ、既定は前後5年)。 */
export function fiscalYearOptions(centerYear: number, range = 5): number[] {
  const out: number[] = []
  for (let y = centerYear - range; y <= centerYear + range; y++) {
    out.push(y)
  }
  return out
}

/** 登録済み特異日の日付から年度セレクタの選択肢 (昇順) を導出する。 */
export function fiscalYearOptionsFromDates(dates: Date[]): number[] {
  const years = new Set<number>()
  for (const d of dates) {
    years.add(fiscalYearOf(d))
  }
  return [...years].sort((a, b) => a - b)
}

/**
 * 登録モーダルの日付初期値 (spec AC-004)。 選択中の年度が当年度なら今日、
 * それ以外の年度なら当該年度の 4/1 を返す (= 通常フローを年度内に誘導しつつ、
 * 年度をまたぐ登録も入力で行える)。
 */
export function defaultCreateDate(
  fiscalYear: number,
  now: Date = serverNow(),
): Date {
  if (defaultFiscalYear(now) === fiscalYear) {
    return new Date(now.getFullYear(), now.getMonth(), now.getDate())
  }
  // 4 月 = month index 3。
  return new Date(fiscalYear, 3, 1)
}
